var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"doc-icon-badge",class:{ 'doc-icon-badge--tiled': _vm.tile }},[_c('span',{staticClass:"doc-icon-circle"},[_c('omk-icon',[_vm._v(_vm._s(_vm.icon))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }